<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="page">

    <div v-if="model != null">
      <van-panel class="panel-info">
        <van-cell slot="header" icon="friends-o" :title="'新店员申请' + '['+ model.id +']'">
          <van-tag v-if="model.checkStatus == 0" type="primary" size="medium">待审核</van-tag>
          <van-tag v-if="model.checkStatus == 1" type="success"  size="medium">已通过</van-tag>
          <van-tag v-if="model.checkStatus == -1" size="medium">不通过</van-tag>
          <van-tag v-if="model.checkStatus == 2" type="danger">待验证</van-tag>
          <van-tag v-if="model.checkStatus == 3" color="blue">已成为店员</van-tag>
        </van-cell>
        <div class="content">
          <div class="row">
            <span class="label">申请人：</span>
            <div style="display: flex;align-items: center;justify-content: space-around">
              <img width="50" height="50" style="border-radius: 50%;margin-right: 5px;" :src="model.userAvatar" >
              <span>{{model.userNickName}}</span>
              <span v-if="model.distributorName" style="font-size: 11px;margin-left: 5px;color: red;">
                推荐人：{{ model.distributorName }}
              </span>
            </div>
          </div>
<!--          <div class="row">-->
<!--            <span class="label">昵称：</span>-->
<!--          </div>-->
          <div class="row">
            <span class="label">图片</span>
            <img v-for="(item, index) in model.photoUrls" :src="item" :key="index" width="50" height="50"
                 style="border-radius: 5px; margin-right: 5px" @click="handleclickImg(model.photoUrls,index)"/>
          </div>
          <div class="row">
            <span class="label">录音</span>
            <van-button type="primary" size="small" plain @click="playAudio()">{{ playAudioBtnText }}</van-button>
            <audio ref="audio" :src="model.audioUrl"></audio>
          </div>
          <div v-if="model.guildName" class="row">
            <span class="label">公会名称</span><span class="value">{{ model.guildName }}</span>
          </div>
          <div class="row">
            <span class="label">店员名字</span><span class="value">{{ model.name }}</span>
          </div>
          <div class="row">
            <span class="label">性别</span>
            <span class="value">{{ $store.state.ClerkSexEnum.getLabel(model.sex) }}</span>
          </div>
          <div class="row">
            <span class="label">经验</span><span class="value">{{ model.workExperience }}</span>
          </div>
          <div class="row">
            <span class="label">地区</span><span class="value">{{ model.regionNames.join('-') }}</span>
          </div>
          <div class="row">
            <span class="label">年龄</span><span class="value">{{ model.age }}</span>
          </div>
          <div class="row">
            <span class="label">微信号</span>
            <span class="value">{{ model.wechatId }}</span>
            <button class="van-button van-button--primary van-button--small" style="height: 20px;line-height: 18px;"
                    v-clipboard="copyUserWechatId" @success="copyCallback(true)" @error="copyCallback(false)">复制微信号
            </button>
          </div>
          <div class="row">
            <span class="label">用户id</span>
            <span v-if="model.checkStatus >= 1 || model.currentLeaderId == model.checkLeaderId"
                  class="value">{{ model.userId }}</span>
            <span v-else class="value">***</span>
            <van-tag v-if="model.checkStatus < 1 && model.sumTotalAmount && model.sumTotalAmount >= 500" type="danger"
                     size="medium">此申请人为老顾客，不建议入店
            </van-tag>
          </div>
          <div v-if="model.checkStatus == 1" class="row">
            <span class="label">组长</span>
            <span v-if="model.checkLeaderId" class="value">{{ model.leaderName }}</span>
          </div>
          <div class="row">
            <span class="label">手机号码</span>
            <span class="value">+{{phoneNumber.mobileDial}}  {{ phoneNumber.mobile }}</span>
            <van-button v-if="model.checkStatus == 1" @click="phoneShow = true" style="height: 20px;background: #07c160;color: #fff">修改手机号</van-button>
          </div>
          <div class="row">
            <span class="label">个性签名</span><span class="value">{{ model.signature }}</span>
          </div>
          <div class="row">
            <span class="label">创建时间</span>
            <span class="value">{{ formatDate(model.create_time, 'YYYY-MM-DD HH:mm:ss') }}</span>
          </div>
          <div v-if="$hasFeature('user_violation_share') && model.userViolationSignList && model.userViolationSignList.length > 0" class="row">
            <span class="label">违规记录</span><span class="value">
                      <span class="text-blue">{{model.userViolationSignList.length}}</span>条
                      <a class="text-blue" @click="showViolation = true">查看</a>
                    </span>
          </div>
          <div v-if="$hasFeature('multiple_shop_clerk') && model.otherShop" class="row">
            <span class="label">串店信息</span>
            <span class="value">
              <span class="text-orange">{{model.otherShop.length}}</span>条
              <a class="text-orange" @click="showOtherShopDialog = true">查看</a>
            </span>
          </div>
        </div>

        <div  class="padding">
          <van-button v-if="model.checkStatus == 0" type="primary" block @click="updateClerkApply">通过审核</van-button>
          <van-button v-if="model.checkStatus == 0" type="danger" block @click="reasonShow = true" style="margin-top: 10px">不通过</van-button>
        </div>

        <div v-if="model.checkStatus == 1" class="padding">
          <van-button type="primary" block @click="submitAddApplyToClerk">添加为店员</van-button>
        </div>

      </van-panel>

      <van-dialog v-model="reasonShow" title="不通过原因" show-cancel-button :before-close="noPass">
        <div class="padding-sm">
          <van-field
              v-model="noPassReason"
              :autosize="autoHeight"
              maxlength="100"
              type="textarea"
              placeholder="请输入不通过原因"
              show-word-limit
              style="border: 1px solid #efefef"
          />
        </div>
      </van-dialog>

      <van-dialog  v-model="phoneShow" :before-close="phoneOk" title="修改手机号" show-cancel-button >
        <div style="padding: 20px 5px;text-align: center;font-size: 16px">
          <CommonTelInput v-model="phoneNumber" :key="phoneNumber.regionCode" @validChange="onValidChange" :customStyle="{border:'1px solid lightgrey'}" />
        </div>
      </van-dialog>
      <!--  查看违规内容  -->
      <ViolationSelect :showViolation="showViolation" :userViolationSignList="model.userViolationSignList"
                       @changeShowViolation="changeShowViolation"></ViolationSelect>
      <OtherShopDialog v-model="showOtherShopDialog" :other-shop="model.otherShop" @changeShowOtherShop="showOtherShopDialog=false" />
      <!--  添加店员 -->
      <van-dialog v-model="addClerkModel.show" title="确定要添加成为店员吗?" class="title"
                  @confirm="onOk" @cancel="addClerkModel.show=false" show-cancel-button="true" >
        <div>
          <div v-if="$hasFeature('clerk_group')" style="margin: 5px;">
            <div show-icon class="warning">
              <van-icon name="warning" color="orange" style="margin: 5px" />
              <div>点击选项框可以为店员进行分组<span style="color: darkgrey;margin-left: 10px">(非必选项)</span></div>
            </div>
            <van-field
                :colon="true"
                :value="addClerkModel.group"
                clickable
                label="分组"
                placeholder="请选择分组"
                readonly
                @click="openPicker(groupColumn,(value)=>{addClerkModel.group = value})"/>
          </div>
        </div>
      </van-dialog>
      <van-popup v-model="picker.show" position="bottom" round>
        <van-picker
            :columns="picker.columns"
            show-toolbar
            @cancel="onPickerCancel"
            @confirm="onPickerConfirm"/>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Panel, Cell, CellGroup, Button, Tag, Icon, Toast, Dialog, Field, ImagePreview,Popup,Picker} from 'vant';
import Decimal from 'decimal.js';
import moment from 'moment';
import VueClipboards from 'vue-clipboards';
import {
  getClerkApply,
  updateClerkApply,
  addApplyToClerk,
  phoneClerk
} from '@/api/guilder/clerk_apply'

import CommonTelInput from "@/components/common/tel-input/CommonTelInput";
import ViolationSelect from '@/components/common/violation-select'
import OtherShopDialog from "@/components/common/other-shop-dialog";

Vue.use(Panel)
    .use(Cell)
    .use(CellGroup)
    .use(Button)
    .use(Tag)
    .use(Icon)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(ImagePreview)
    .use(Popup)
    .use(Picker)

Vue.use(VueClipboards);

export default {
  name: 'clerk-apply-detail',
  components: {
    OtherShopDialog,
    CommonTelInput,
    ViolationSelect
  },
  data() {
    return {
      showViolation: false,
      showOtherShopDialog: false,
      noPassReason: null,
      autoHeight: {minHeight: 100},
      show: false,
      phoneShow: false,
      reasonShow: false,
      model: null,
      isPlayAudio: false,
      playAudioBtnText: '播放录音',
      phoneNumber: {
        regionCode:null,
        mobileDial:null,
        isValid:false,
        mobile: null,
      },
      ddUserId: null,
      verifyCode: null,
      picker: {
        show: false,
        columns: [],
        onConfirm: null,
        onCancel: null
      },
      addClerkModel:{
        show: false,
        groupList:[],
        group:null
      }
    }
  },
  computed: {
    groupColumn() {
      let columns = []
      let ClerkGroupMap = this.$store.state.ClerkGroupMap
      for(let item of this.model.clerkGroupList) {
        columns.push(ClerkGroupMap[item.id])
      }
      if (columns.length < 1) columns = ['全部']
      return columns
    }},
  methods: {
    onOk() {
      let groupId = null;
      if (this.addClerkModel.group) {
        groupId = (this._.invert(this.$store.state.ClerkGroupMap))[this.addClerkModel.group]
      }
      // 添加成为店员
      addApplyToClerk(
          this.$route.params.id,
          groupId,
          this.ddUserId,
          this.verifyCode
      ).then((res) => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          this.loadData()
          Toast.success('添加成功')
        } else {
          Dialog.alert({
            title: '添加失败',
            message: data.msg
          })
        }
      })
    },
    openPicker(columns, onConfirm,onCancel) {
      this.picker.columns = columns
      this.picker.onConfirm = onConfirm
      if(!onCancel){
        onCancel = () => {
          onConfirm(null)
        }
      }
      this.picker.onCancel = onCancel;
      this.picker.show = true
    },
    onPickerConfirm(value) {
      if (this.picker.onConfirm) {
        this.picker.onConfirm(value)
      }
      this.picker.show = false
    },
    onPickerCancel(value) {
      if (this.picker.onCancel) {
        this.picker.onCancel(value)
      }
      this.picker.show = false
    },
    changeShowViolation(val){
      this.showViolation = val
    },
    handleclickImg(photoUrls, index) {
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },
    onValidChange(isValid){
      this.phoneNumber.isValid = isValid;
    },
    phoneOk(action,done){
      if (action === 'confirm') {
        if (this.phoneNumber.mobile === '' || !this.phoneNumber.mobile) {
          Toast('请输入手机号');
          done(false)
          return
        } else if (!this.phoneNumber.isValid) {
          Toast('请输入正确的手机号');
          done(false)
          return
        }
        phoneClerk(this.model.id, this.phoneNumber.regionCode, this.phoneNumber.mobile).then((res) => {
          const data = res.data
          if (data.code === 0) {
            Toast('修改成功');
            done()
            this.loadData()
          } else {
            Toast('修改失败');
          }
        })
      }else {
        done()
      }
    },
    noPass(action, done) {
      if (action == 'confirm') {
        if (this.noPassReason == null || this.noPassReason == '') {
          Toast.fail("请填写原因")
          done(false)
          return
        }
        Toast.loading({
          mask: true,
          message: '请稍候'
        })
        updateClerkApply(this.$route.params.id, -1, this.noPassReason).then((res) => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            this.loadData()
            done()
            Toast.success('审核成功')
          } else {
            done(false)
            Toast.fail(data.msg)
          }
        })
      } else {
        done()
      }
    },
    copyCallback(isSuccess) {
      if (isSuccess) {
        Toast('复制成功')
      } else {
        Toast('复制失败，请长按文本复制')
      }
    },
    submitAddApplyToClerk(){
      this.addClerkModel.group=null
      this.addClerkModel.show=true
    },
    /** 复制微信号 */
    copyUserWechatId() {
      if (this.model) {
        return this.model.wechatId
      }
      return null
    },
    /** 播放录音 */
    playAudio() {
      if (this.isPlayAudio) {
        this.$refs.audio.pause()
        this.isPlayAudio = false
        this.playAudioBtnText = '播放录音'
      } else {
        this.$refs.audio.play()
        this.isPlayAudio = true
        this.playAudioBtnText = '暂停播放'
      }
      // 监听录音播放结束事件
      this.$refs.audio.addEventListener('ended', () => {
        this.isPlayAudio = false
        this.playAudioBtnText = '播放录音'
      })
    },
    /** 修改新店员申请 */
    updateClerkApply() {
      Dialog.confirm({
        title: '提示',
        message: '确定通过审核并获取联系方式吗？',
      }).then(() => {
        Toast.loading({
          mask: true,
          message: '请稍候'
        })
        updateClerkApply(this.$route.params.id, 1, null).then((res) => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            this.loadData()
            Toast.success('审核成功')
          } else {
            Toast.fail(data.msg)
          }
        })
      })
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getClerkApply(this.$route.params.id).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.model = data;
          this.phoneNumber.mobile = data.mobile
          this.phoneNumber.regionCode = data.regionCode
          this.phoneNumber.mobileDial = data.mobileDial
          this.model.sumTotalAmount = this.formatPrice(this.model.sumTotalAmount)
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    }
  },
  mounted() {
    this.loadData()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less">
.iti-mobile{
  .iti--container{
    //left: 0;
    //width: 100%;
    //height: 50%;
    //top: 50%;
    //bottom: 0;
    z-index: 3000;
  }
}

</style>
<style lang="less" scoped>

.page {
  padding-bottom: 100px;

  .panel-info {
    margin-top: 10px;

    .content {
      font-size: 14px;
      padding: 10px 15px;

      .row {
        display: flex;
        color: #333;
        margin: 10px 0;
        align-items: center;

        .label {
          width: 80px;
          color: #888;
        }

        .value {
          flex: 1;
        }
      }
    }
  }

}
</style>
